export default __webpack_public_path__ + "static/lightsOn-2fe29538ab30d28867b18271bc9be84e.jpg";